import { useLayoutEffect, useRef } from 'react';
import { getBackNavigation } from '../utils/backNavigation';

export default function useBackHandler(active, onBack, priority = 1201) {
    const latest = useRef(onBack);
    latest.current = onBack;
    useLayoutEffect(() => {
        if (!active) return undefined;
        return getBackNavigation().register(() => latest.current?.(), priority);
    }, [active, priority]);
}
